export class StartStreamingSessionRequest {

  cultureName?: string;
  environmentId?: string;
  fleetKind?: string;
  timeZoneId?: string;
  onReadyRedirect?: string;
  onErrorRedirect?: string;

  constructor(init?: Partial<StartStreamingSessionRequest>) {
    Object.assign(this, init);
  }
}
